import { apiClient } from './client'
import { API_ENDPOINTS } from '@/utils/constants'
import type { TeacherLessonPrice } from '@/types/billing'

type ApiResponse<T> = { message?: string; data?: T }

function unwrapResource<T>(raw: ApiResponse<T> | T): T {
  if (raw && typeof raw === 'object' && 'data' in raw) {
    return (raw as ApiResponse<T>).data as T
  }
  return raw as T
}

export type TeacherPricesResponse = {
  active: TeacherLessonPrice | null
  history: TeacherLessonPrice[]
}

export const teacherPricesApi = {
  index: async (): Promise<TeacherPricesResponse> => {
    const response = await apiClient.get<ApiResponse<TeacherPricesResponse>>(
      API_ENDPOINTS.TEACHER_PRICES
    )
    const data = unwrapResource(response.data)
    return {
      active: data.active ?? null,
      history: Array.isArray(data.history) ? data.history : [],
    }
  },

  store: async (payload: {
    price_per_hour: number
    currency?: string
    effective_from?: string
  }): Promise<TeacherLessonPrice> => {
    const response = await apiClient.post<ApiResponse<TeacherLessonPrice>>(
      API_ENDPOINTS.TEACHER_PRICES,
      payload
    )
    return unwrapResource(response.data)
  },
}
